import { type Header } from '@tanstack/react-table';
import { cn } from '../../lib/utils';

export interface ColumnResizeHandleProps {
  header: Header<any, unknown>;
}
export const ColumnResizeHandle = ({ header }: ColumnResizeHandleProps) => {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      onDoubleClick={header.column.resetSize}
      onMouseDown={(e) => {
        e.preventDefault();
        const element = (e.target as HTMLElement).closest('[data-slot="table-head"]');
        if (!element) return;
        const { clientWidth = 0 } = element;

        // Override so TanStack captures the real DOM width
        // for both `startSize` (header.getSize) and `columnSizingStart`.
        const origHeaderGetSize = header.getSize;
        const origColGetSize = header.column.getSize;
        header.getSize = () => clientWidth;
        header.column.getSize = () => clientWidth;

        header.getResizeHandler()(e);

        header.getSize = origHeaderGetSize;
        header.column.getSize = origColGetSize;
      }}
      className={cn(
        'absolute top-0 z-10 flex h-full w-4 cursor-col-resize touch-none select-none items-stretch justify-center',
        '-right-2',
        'after:w-1 after:bg-border after:opacity-0 after:content-[""] hover:after:opacity-100',
        header.column.getIsResizing() && 'after:opacity-100 after:bg-primary/60',
      )}
    />
  );
};
